import { render, staticRenderFns } from "./ChiefComplaintAdviceGuidance.vue?vue&type=template&id=5df689e4&scoped=true&"
import script from "./ChiefComplaintAdviceGuidance.vue?vue&type=script&lang=js&"
export * from "./ChiefComplaintAdviceGuidance.vue?vue&type=script&lang=js&"
import style0 from "./ChiefComplaintAdviceGuidance.vue?vue&type=style&index=0&id=5df689e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df689e4",
  null
  
)

export default component.exports